import lodash from 'lodash';

export default class Meta {

    constructor(options) {  
        options = options || {};

        this.events     = [];
        this.attributes = [];
        this.component  = undefined;
        
        if( options.hasOwnProperty('events') ) {
            this.events = options.events
        };

        if( options.hasOwnProperty('attributes') ) {
            this.attributes = options.attributes
        };

        if( options.hasOwnProperty('component') ) {
            this.component = options.component
        };
    }
}


// WEBPACK FOOTER //
// ./src/components/common/table_v3/Meta.js